export const discountCodesSelector = s => s.discountCodes.codes;

export const discountCodeSelector = s => s.discountCodes.code;

export const discountCodesLoadingSelector = s => s.discountCodes.loading;

export const discounCodesErrorSelector = s => s.discountCodes.error;
